import { DeviceType, useDeviceType } from '@sweetspot/scramble-ds/utils'

export function useIsMobile() {
  const { deviceType } = useDeviceType()

  return deviceType === DeviceType.MOBILE
}
